import { render, staticRenderFns } from "./outgoingProductRecord.vue?vue&type=template&id=554ead4a&scoped=true"
import script from "./outgoingProductRecord.vue?vue&type=script&lang=js"
export * from "./outgoingProductRecord.vue?vue&type=script&lang=js"
import style0 from "./outgoingProductRecord.vue?vue&type=style&index=0&id=554ead4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554ead4a",
  null
  
)

export default component.exports